// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"K1-z","dimensionLabel":"L1-z","styleChooserControlWrapper":"M1-z","styleChooserControl":"N1-z","disabled":"O1-z","giftCard":"P1-z","styleChooserText":"Q1-z"};